module.exports = __webpack_public_path__ + "img/photo_2024-03-09_01-10-28.eb6b52e6.jpg";